import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { useCoordinatePatientsActions } from 'stores/patientFiltersStore';

function CoordinateLayout() {
  const { reset } = useCoordinatePatientsActions();

  useEffect(() => {
    return () => {
      reset();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Outlet />;
}

export default CoordinateLayout;
